import { locale } from 'helpers/intl-helper';

export const sortTagsByDisplayValue = (tags) =>
  tags.sort((aTag, bTag) => {
    const aDisplayValue = aTag.display_value || '';
    const bDisplayValue = bTag.display_value || '';

    return aDisplayValue.localeCompare(bDisplayValue, locale, {
      numeric: true,
    });
  });

export const convertTagsDataToLegacyFormat = (data) => {
  const photoTags = data?.viewer?.project?.photoTags?.nodes || [];
  const videoTags = data?.viewer?.project?.videoTags?.nodes || [];
  const allTags = [...photoTags, ...videoTags];

  const uniqueTagsSet = new Set();
  const legacyTags = [];

  allTags.forEach((tag) => {
    if (!uniqueTagsSet.has(tag.id)) {
      uniqueTagsSet.add(tag.id);

      legacyTags.push({
        id: parseInt(tag.databaseId, 10),
        display_value: tag.displayValue,
        node_id: tag.id,
      });
    }
  });

  return sortTagsByDisplayValue(legacyTags);
};
